import { memo, PropsWithChildren, useMemo } from 'react';
import { Button } from 'src/modules/common/components/Button/Button';
import { CrossIcon } from 'src/modules/common/icons/CrossIcon';
import { I18n } from 'src/modules/common/components/I18n/I18n.tsx';

type Props = PropsWithChildren<{
    title?: string;
    description?: string;
    handleClose?: () => void;
}>

export const ModalHeader = memo(({ title, description, children, handleClose }: Props) => {
    const translatedDescription = useMemo(() => (description ? <I18n messageId={description}/> : null), [description]);

    return (
        <div className="vss-modal-header">
            {handleClose && (
                <Button className="vss-modal-close-button" kind="ghost" iconOnly={true} onClick={handleClose}>
                    <div className="vss-modal-header__close-icon">
                        <CrossIcon/>
                    </div>
                </Button>
            )}

            {title ? (<p className="vss-modal-header__title"><I18n messageId={title}/></p>) : null}

            <p className="vss-modal-header__description">{children || translatedDescription}</p>
        </div>
    );
});
